import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

type BaseProps = {
  className?: string;
  style?: React.CSSProperties;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

function Root({ className, style, content, children = content }: BaseProps) {
  return (
    <div className={cx(styles.root, className)} style={style}>
      {children}
    </div>
  );
}

function Header({ className, style, content, children = content }: BaseProps) {
  return (
    <header className={cx(styles.header, className)} style={style}>
      {children}
    </header>
  );
}

function BeforeMain({
  className,
  style,
  content,
  children = content,
}: BaseProps) {
  return (
    <div className={cx(styles.beforeMain, className)} style={style}>
      {children}
    </div>
  );
}

function Main({ className, style, content, children = content }: BaseProps) {
  return (
    <main className={cx(styles.main, className)} style={style}>
      {children}
    </main>
  );
}

function Left({ className, style, content, children = content }: BaseProps) {
  return (
    <div className={cx(styles.left, className)} style={style}>
      {children}
    </div>
  );
}

function Center({ className, style, content, children = content }: BaseProps) {
  return (
    <div className={cx(styles.center, className)} style={style}>
      {children}
    </div>
  );
}

function Right({ className, style, content, children = content }: BaseProps) {
  return (
    <div className={cx(styles.right, className)} style={style}>
      {children}
    </div>
  );
}

function Footer({ className, style, content, children = content }: BaseProps) {
  return (
    <footer className={cx(styles.footer, className)} style={style}>
      {children}
    </footer>
  );
}

const Layout = {
  Root,
  Header,
  BeforeMain,
  Main,
  Left,
  Center,
  Right,
  Footer,
};

export default Layout;
